/**
 * Il nome canonico di una porta di rete: `Gi1/0/1` e `GigabitEthernet1/0/1`
 * sono la stessa porta, e lo sono `GE1/0/1` (Huawei) e `Eth1/1`/`Ethernet1/1`
 * (Nexus). `ifName` (SNMP) abbrevia, l'inventario scrive per esteso: un
 * confronto alla lettera lasciava il transceiver senza la sua porta.
 *
 * La tabella è la stessa di `control-plane/app/services/porte.py`, e una
 * prova (`test_porte.py`) le tiene uguali.
 */
// Coppie e non un dizionario `chiave: 'valore'`: i gettoni («xge», «vlan»)
// non sono etichette da tradurre, e la guardia delle traduzioni legge le
// tabelle di etichette proprio in quella forma.
const SINONIMI: Record<string, string> = Object.fromEntries([
  ['gigabitethernet', 'ge'],
  ['gi', 'ge'],
  ['ge', 'ge'],
  ['gige', 'ge'],
  ['tengigabitethernet', 'xge'],
  ['te', 'xge'],
  ['xge', 'xge'],
  ['tengige', 'xge'],
  ['10ge', 'xge'],
  ['twentyfivegige', '25ge'],
  ['twe', '25ge'],
  ['25ge', '25ge'],
  ['fortygigabitethernet', '40ge'],
  ['fo', '40ge'],
  ['40ge', '40ge'],
  ['fortygige', '40ge'],
  ['hundredgige', '100ge'],
  ['hu', '100ge'],
  ['100ge', '100ge'],
  ['hundredgigabitethernet', '100ge'],
  ['fastethernet', 'fe'],
  ['fa', 'fe'],
  ['fe', 'fe'],
  ['ethernet', 'eth'],
  ['eth', 'eth'],
  ['et', 'eth'],
  ['port-channel', 'po'],
  ['po', 'po'],
  ['eth-trunk', 'po'],
  ['bundle-ether', 'po'],
  ['be', 'po'],
  ['ae', 'po'],
  ['vlan', 'vlan'],
  ['vl', 'vlan'],
  ['vlanif', 'vlan'],
  ['loopback', 'lo'],
  ['lo', 'lo'],
  ['tunnel', 'tu'],
  ['tu', 'tu'],
  ['null', 'nu'],
  ['nu', 'nu'],
  ['mgmt', 'mgmt'],
  ['meth', 'mgmt'],
  ['management', 'mgmt'],
  ['mgmteth', 'mgmt'],
  ['serial', 'se'],
  ['se', 'se'],
] as const)

const FORMA = /^\s*([a-z][a-z-]*?)\s*(\d[\d/.:-]*)?\s*$/

export function nomePortaCanonico(nome: string | null | undefined): string {
  if (!nome) return ''
  const grezzo = nome.trim().toLowerCase()
  const m = FORMA.exec(grezzo)
  if (!m || !m[2]) return grezzo.replace(/\s+/g, '')
  return (SINONIMI[m[1]] ?? m[1]) + m[2]
}

export function stessaPorta(a: string | null | undefined, b: string | null | undefined): boolean {
  return Boolean(a && b && nomePortaCanonico(a) === nomePortaCanonico(b))
}
